import React from 'react';
import style from './InfoSection.module.css';
import tomekPhoto from '../assets/images/team photos/tomek.jpg';
import edwardPhoto from '../assets/images/team photos/edward.jfif';
import arekPhoto from '../assets/images/team photos/arek.jpg';
import kacperPhoto from '../assets/images/team photos/kacper.jpg';
import przemekPhoto from '../assets/images/team photos/przemek.jpg';
import krystianPhoto from '../assets/images/team photos/krystian.jpg';
import Teammate from "./blocks/Teammate";
import SoftwarelyLogo from "../assets/svg/SoftwarelyLogo";
import LinkButton from "../UI/buttons/LinkButton";
import logoZZW from "../assets/images/logoZZW.png";
import logoPZW from "../assets/images/logoPZW.png";
import SggwLogoSvg from "../assets/svg/SggwLogoSvg";
import TeamAction from "./blocks/TeamAction";
import WaterLevelSvg from "../assets/svg/WaterLevelSvg";
import WaterTemperatureSvg from "../assets/svg/WaterTemperatureSvg";
import HandshakeSvg from "../assets/svg/HandshakeSvg";

function InfoSection() {

    const TEAM = [
        {photo: tomekPhoto, name: 'Tomasz', surname: 'Dziedzicki', role: 'CEO@Softwarely'},
        {photo: edwardPhoto, name: 'Eduard', surname: 'Savchuk', role: 'Frontend Developer'},
        {photo: arekPhoto, name: 'Arkadiusz', surname: 'Fabiański', role: 'UX Designer'},
        {photo: kacperPhoto, name: 'Kacper', surname: 'Zezuliński', role: 'Hardware Engineer'},
        {photo: przemekPhoto, name: 'Przemysław', surname: 'Jesinowicz', role: 'Embedded Software Engineer'},
        {photo: krystianPhoto, name: 'Krystian', surname: 'Król', role: 'Technical Consultant'}
    ]

    const ACTIONS_ICON_MAIN_COLOR = "#3AA9F5"

    const ACTIONS = [
        {
            title: "Automatyczne pomiary poziomu wody",
            text: "Monitorujemy poziom wody, aby zapobiegać suszom i powodziom.",
            icon: <WaterLevelSvg
                color={ACTIONS_ICON_MAIN_COLOR}
                className={style.actionsIcon}
                opacity="1"
            />
        },
        {
            title: "Kontrola temperatury wody",
            text: "Analizujemy temperaturę wody, co pozwala na wczesne wykrywanie niekorzystnych zmian klimatycznych.",
            icon: <WaterTemperatureSvg
                color={ACTIONS_ICON_MAIN_COLOR}
                className={style.actionsIcon}
                opacity={{external: "1", internal: "0.5"}}
            />
        },
        {
            title: "Współpraca z lokalnymi społecznościami",
            text: "Angażujemy mieszkańców w działania na rzecz ochrony środowiska, edukując i wspierając lokalne inicjatywy.",
            icon: <HandshakeSvg
                color={ACTIONS_ICON_MAIN_COLOR}
                className={style.actionsHandshakeIcon}
            />
        }
    ]

    return (
        <div className={style.main}>
            <div>
                <div className={style.title}>
                    Zespół
                </div>

                <div className={style.teammates}>
                    {TEAM.map(t =>
                        <Teammate
                            photo={t.photo}
                            name={t.name}
                            surname={t.surname}
                            role={t.role}
                            key={t.role}
                        />
                    )}
                </div>
            </div>

            <div>
                <SoftwarelyLogo />
            </div>

            <div className={style.pageTextBlock}>
                Nasza firma z dumą ogłasza nawiązanie współpracy z czołowymi organizacjami ekologicznymi w celu monitoringu jezior. Wspólnie dążymy do ochrony tych cennych ekosystemów przy pomocy systemu WOLF.
            </div>

            <div>
                <LinkButton url="https://wolf.softwarely.pl">
                    System WOLF
                </LinkButton>
            </div>

            <div>
                Nasze działania obejmują:
            </div>

            <div className={style.actions}>
                { ACTIONS.map(action =>
                    <TeamAction
                        key={action.title}
                        title={action.title}
                        text={action.text}
                        icon={action.icon}
                    />
                )}
            </div>

            <div className={style.pageTextBlock}>
                Dzięki zaawansowanym technologiom i wspólnym wysiłkom, możemy skutecznie reagować na zmiany środowiskowe wspierając ich zrównoważony rozwój.
            </div>

            <div>
                <div className={style.title}>
                    Partnerzy
                </div>

                <div className={style.partnersLogos}>
                    <div className={style.logoZZW}>
                        <img src={logoZZW} alt="Zarząd Zieleni m.st. Warszawy" />
                    </div>

                    <div className={style.logoPZW}>
                        <img src={logoPZW} alt="Okręg Mazowiecki PZW"/>
                    </div>

                    <div className={style.logoSGGW}>
                        <SggwLogoSvg />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InfoSection;